
<script>
    import broker from '../../utils/broker'
    export default {
        props : ['meta'],
        components: {
            
        },
        data () {
            return {
                page : 1,
                limit : 12,
                gallery : [],
                currentPage :0,
                lastPage : 0,
                paging : []
            }
        },
        mounted(){
           this.getData(1)
        },
        methods : {
            getData(page){
                broker.fetch.get(`/webschool/content?page=${page}&limit=${this.limit}&types[]=gallery&status=published`)
                .then(res => {
                    const data = res.data.data
                    const meta = res.data.meta
                    this.gallery = data
                    this.currentPage = meta.current_page
                    this.lastPage = meta.last_page
                    this.pageNumbers()

                });
            },
            goPage(type){
                let number = 0;
                if (type === "next") {
                    number = this.currentPage + 1
                } else {
                    number = this.currentPage - 1
                }

                broker.fetch.get(`/webschool/content?page=${number}&limit=${this.limit}&types[]=gallery&status=published`)
                .then(res => {
                    const data = res.data.data
                    const meta = res.data.meta
                    this.gallery = data
                    this.currentPage = meta.current_page
                    this.lastPage = meta.last_page
                    this.pageNumbers()

                });
            },
            pageNumbers() {
                var result = [];
                if (this.lastPage - this.currentPage <= 2) {
                // if (this.currentPage > this.lastPage - this.limit) {
                    // result.push(this.lastPage - 2, this.lastPage - 1, this.lastPage);
                    if (this.lastPage -2 > 0)
                        result.push(this.lastPage - 2)
                    
                    if (this.lastPage -1 > 0)
                        result.push(this.lastPage - 1)

                    if (this.lastPage)
                        result.push(this.lastPage)

                } else {
                    result.push(this.currentPage, this.currentPage + 1, this.currentPage + 2, '...', this.lastPage);
                }
                 
                this.paging = result;
            },
            test(){
                console.log("test")
            }
        },
    };
</script>
<template>
    <div class="page-wrapper section-space--inner--60">
        <div class="blog-section">
             <div class="justify-content-center mb-3">
                <div class="col-sm-12 text-center">
                    <h3 class="text-color-orange font-size-24">Galeri Foto</h3>
                    <h2>Macam-macam Kegiatan yang Produktif</h2>
                    <p class="font-size-15">{{ this.meta.name }} merupakan salah satu pelopor sekolah unggulan terbaik di indonesia dengan mendukung sistem pengajaran 4.0</p>
                </div>
            </div>
            <div class="grey-bg p-md-4 mb-5">
                <div class="container">
                    <button type="button" class="btn ht-btn-orange--round mr-3">Semua</button>
                    <button type="button" class="btn ht-btn-light-orange--round mr-3">Siswa</button>
                    <button type="button" class="btn ht-btn-light-orange--round mr-3">Guru</button>
                </div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="row">
                            <div v-for="(item) in gallery" :key="item.id" class="col-xl-3 col-lg-4 col-sm-6 col-12 section-space--top--20" >
                               <router-link to="#" class="gallery-item single-gallery-thumb">
                                    <img :src="item.image" class="img-fluid" alt="thumbnail">
                                    <span class="span-text text-white">{{item.title}}</span>
                                </router-link>
                            </div> 
                        </div>
                    </div>
                </div>
                <div class="row ">
                    <div class="col">
                        <ul class="page-pagination-orange section-space--top--30">
                            <li :class="[(currentPage === 1) ? 'btn-disabled' : '']"><a @click="goPage('prev')"><i class="fa fa-angle-left"></i> Sebelumnya</a></li>

                                <li v-for="page in paging"
                                :key="page" :class="[(currentPage === page || page === '...') ? 'active btn-disabled' : '']"><a @click="getData(page)">{{page}}</a>
                            </li>
                            <!--
                            <li class="active"><a href="#">01</a></li>
                            <li><a href="#">02</a></li>
                            <li><a href="#">03</a></li>
                            -->
                            <li  :class="[(currentPage === lastPage) ? 'btn-disabled' : '']"><a @click="goPage('next')"><i class="fa fa-angle-right"></i> Selanjutnya</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .row-button-list{
        margin-left : 120px;
    }
</style>
